/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });

import { createApp } from 'vue';

// This is the main application Vue component.
import MainApp from './components/MainApp.vue';

// Refresh Application
import RefreshApplication from './components/RefreshApplication.vue';

// Processed Application
import ProcessedApplication from './components/ProcessedApplication.vue';

// Iframe (cross-domain iframe-embeddable form)
import IframeApp from './components/IframeApp.vue';


import VueApexCharts from "vue3-apexcharts";

import i18n from './i18n.js';
import { storageGet, storageSet } from './utils/safe-storage.js';

const mountEl = document.querySelector('#app');

if (mountEl) {
    createApp({
        components: {
            MainApp,
            ProcessedApplication,
            RefreshApplication,
            IframeApp,
        },
        setup() {
            const urlParams = new URLSearchParams(window.location.search);
            const preferredLang =  window.App?.locale || urlParams.get('lang') || null;
            const locale = preferredLang || storageGet('lc-locale') || 'en';
            i18n.global.locale = locale;
            storageSet('lc-locale', locale);
        },
    })
    .use(VueApexCharts)
    .use(i18n)
    .mount(mountEl);
}
